module.exports = __webpack_public_path__ + "static/media/BGpattern.6c012d9b.png";